<template>
  <section class="sick-signs new-report__section">
    <h3 class="new-report__heading">
      SIGNS OF SICK DEER (CLICK ALL BOXES THAT APPLY)
    </h3>
    <section class="new-report__checkbox-container">
      <checkbox-row v-for="sign in signs" :key="sign.id" :checkbox="sign" />
      <div class="checkbox-row checkbox-row--full">
        <label for="symptomOther" class="sick-signs__label">Other</label>
        <input
          id="symptomOther"
          class="sick-signs__other"
          type="text"
          :value="other"
          @keyup="debounceOtherSymptom"
          @blur="updateOtherSymptom"
        />
      </div>
    </section>
  </section>
</template>

<script>
import CheckboxRow from "./CheckboxRow";
import { mapMutations } from "vuex";
import { debounce } from "lodash";

export default {
  components: {
    CheckboxRow,
  },
  data() {
    return {
      signs: [
        {
          id: "signs_deer1",
          label: "No fear of humans",
          name: "symptom1",
          type: "symptoms",
        },
        {
          id: "signs_deer2",
          label: "Animal is reluctant to get up or move",
          name: "symptom7",
          type: "symptoms",
        },
        {
          id: "signs_deer3",
          label: "Repeated patterns of walking",
          name: "symptom4",
          type: "symptoms",
        },
        {
          id: "signs_deer4",
          label: "Severe emaciation",
          name: "symptom6",
          type: "symptoms",
        },
        {
          id: "signs_deer5",
          label: "Difficultly walking or standing",
          name: "symptom3",
          type: "symptoms",
        },
        {
          id: "signs_deer6",
          label: "Drooping of head and ears",
          name: "symptom2",
          type: "symptoms",
        },
        {
          id: "signs_deer7",
          label: "Excessive salivation or nasal discharge",
          name: "symptom5",
          type: "symptoms",
        },
      ],
    };
  },
  computed: {
    other() {
      return this.$store.state.incidentReport.symptoms.other;
    },
  },
  methods: {
    updateSymptom(event) {
      const symptoms = this.$store.state.incidentReport.symptoms;
      const name = event.target.name;
      const value = event.target.value;
      symptoms[name] = value;
      this.$store.commit("incidentReport/setSymptoms", symptoms);
    },
    updateOtherSymptom(event) {
      const symptoms = $nuxt.$store.state.incidentReport.symptoms;
      const string = event.target.value;
      symptoms.other = string;
      $nuxt.$store.commit("incidentReport/setSymptoms", symptoms);
    },
    debounceOtherSymptom: debounce((event) => {
      const symptoms = $nuxt.$store.state.incidentReport.symptoms;
      const string = event.target.value;
      symptoms.other = string;
      $nuxt.$store.commit("incidentReport/setSymptoms", symptoms);
    }, 300),
  },
};
</script>

<style lang="scss">
.sick-signs {
  &__label {
    width: calc(100% / 7);
    @media only screen and (min-width: 768px) {
      width: calc(100% / 12);
    }
  }
  &__other {
    border: solid black 1px;
    height: 25px;
    margin-left: 4rem;
    padding: 0 0.5rem;
    width: 100%;
  }
}
</style>
